// Phone layout (29 Sep, iPhone 1): decided once at launch from the screen's shorter side. Every iPad's is at least 744 px,
// every iPhone's is under 450, so the cutoff is 600 and rotating never flips it. On the iPad the attribute is "tablet" and no
// phone rule can match. Live on production phones since Tim approved it. For testing on a desktop browser: open with ?device=phone once (kept on that browser), ?device=auto clears it.
const KEY = 'starchive.device'
export const PHONE_LAYOUT_ON = true   // go-live (Tim approved the phone layout); set back to the staging-only line to turn it off

function decide(): 'phone' | 'tablet' {
  let forced: string | null = null
  try {
    const q = new URLSearchParams(window.location.search).get('device')
    if (q === 'phone' || q === 'tablet') localStorage.setItem(KEY, q)
    if (q === 'auto') localStorage.removeItem(KEY)
    forced = localStorage.getItem(KEY)
  } catch { /* private mode */ }
  if (forced === 'phone' || forced === 'tablet') return forced
  if (!PHONE_LAYOUT_ON) return 'tablet'
  const short = Math.min(window.screen.width, window.screen.height)
  return short < 600 ? 'phone' : 'tablet'
}

export const device = decide()
export const isPhone = device === 'phone'
/** The same value for the whole session; a hook only so components read it the React way. */
export const usePhone = () => isPhone
export function markDevice() { document.documentElement.dataset.device = device }

/** Step screens (a sale, a trade, an intake or a QA check in progress) hide the tab bar so nothing is left halfway. */
export function tabBarShown(path: string) {
  if (/^\/(sell|trade)\/./.test(path)) return false
  if (/^\/intake\/(review|recorded)/.test(path)) return false
  if (path.startsWith('/qa/check')) return false
  if (/^\/inbox\/./.test(path)) return false
  return true
}
